// Libs
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// Function to check if user is logged in; customize this as needed
const isAuthenticated = (): boolean => {
  // Example: check if a token exists in localStorage
  return true;
  //   return !!localStorage.getItem("authToken");
};

// ProtectedRoute component acts as middleware
const ProtectedRoute: React.FC = () => {
  if (!isAuthenticated()) {
    // Not logged in, redirect to login page
    return <Navigate to="/login" replace />;
  }

  // Logged in, allow access to child routes/components
  return <Outlet />;
};

export default ProtectedRoute;
